{
  "schemaVersion": 1,
  "id": "grid-bookcase-joints",
  "version": "1.0",
  "name": "Grid bookcase: screwed butt or housed shelves, overlay or rebated back",
  "family": "grid-bookcase",
  "familyId": "grid-bookcase",
  "jointFamily": "butt",
  "provisional": true,
  "reviewer": null,
  "reviewedAt": null,
  "selfAuthored": true,
  "author": "David Mansaray",
  "authoredAt": "2026-10-09",
  "sources": [
    "First-slice construction profile butt-joint-v1 v0.3 (plain butt joints, overlay back), carried over unchanged for one bay",
    "research/taxonomy.md §1.1 Grid: boards and joints in solid timber, construction notes, shelf span limits",
    "PLAN.md §5: housed dado one third of the thickness deep; rebate for backs; glue-ups from boards up to maxWidth"
  ],
  "joint": "Top, bottom and fixed shelves fitted between full-height sides (and dividers between bays): screwed butt joints, glued; fixed shelves may instead be housed one third of the thickness deep into the sides and dividers.",
  "joints": [
    { "at": "bottom-side", "kind": "screwed-butt", "params": { "screwSpec": "4.0 × 50 mm countersunk" } },
    { "at": "top-side", "kind": "screwed-butt", "params": { "screwSpec": "4.0 × 50 mm countersunk" } },
    { "at": "divider-bottom", "kind": "screwed-butt", "params": { "screwSpec": "4.0 × 50 mm countersunk" }, "note": "Through the bottom and the top into the divider ends." },
    { "at": "shelf-side", "kind": "screwed-butt", "params": { "screwSpec": "4.0 × 50 mm countersunk" }, "note": "Housed dado (depth one third of the thickness) when the design asks for housed shelves." },
    { "at": "shelf-divider", "kind": "screwed-butt", "params": { "screwSpec": "4.0 × 50 mm countersunk" }, "note": "Housed dado when the design asks for housed shelves; offset the screws either side of a divider." },
    { "at": "plinth-side", "kind": "screwed-butt", "params": { "screwSpec": "4.0 × 50 mm countersunk" } },
    { "at": "back-carcass", "kind": "screwed-butt", "params": { "screwSpec": "3.5 × 20 mm pan head" }, "note": "Overlay back. A rebated back sits in a rebate b deep and half the thickness wide in the sides, top and bottom." }
  ],
  "envelope": {
    "W": { "min": 4000, "max": 12000 },
    "H": { "min": 6000, "max": 22000 },
    "D": { "min": 2000, "max": 4500 },
    "n": { "min": 0, "max": 8 },
    "minOpeningTicks": 1500
  },
  "bays": { "min": 1, "max": 4, "maxOverallWTicks": 24000, "minBayClearTicks": 2500, "maxPlinthTicks": 1500 },
  "limits": { "maxSpanMm": 800, "minOpeningMm": 150 },
  "edgeAllowanceTicks": 20,
  "cutAllowanceTicks": { "l": 0, "w": 0 },
  "arrisMm": 0.6,
  "intendedUse": "Domestic books and objects; shelves loaded evenly. Not for climbing, not structural.",
  "loadStatement": "Self-authored: no rated load. Books and objects loaded evenly along each shelf; heaviest items on the lowest shelves.",
  "edgeTreatment": "Plywood: exposed ply edges, sanded arris 0.6 mm, lacquered with the faces. Solid timber: planed edges, 1 mm arris, oiled with the faces.",
  "fasteners": [
    {
      "id": "carcass-screw",
      "spec": "4.0 × 50 mm countersunk wood screw",
      "qtyRule": "per-joint",
      "perJoint": 3,
      "use": "Through the sides into each horizontal, 3 per joint at 25 mm from the front and back edges and centred; pilot 2.5 mm, clearance 4.5 mm; PVA glue on all butt joints."
    },
    {
      "id": "back-screw",
      "spec": "3.5 × 20 mm pan-head screw",
      "qtyRule": "back-perimeter-and-shelves",
      "centresMm": 150,
      "use": "Through the back into the sides, top, bottom and every shelf at 150 mm centres, glued."
    },
    {
      "id": "wall-bracket",
      "spec": "Steel angle bracket with fixings suited to the wall",
      "qtyRule": "fixed",
      "qty": 2,
      "use": "Under the top panel into studs, or with masonry plugs or cavity anchors suited to the wall."
    }
  ],
  "backFixing": {
    "method": "Overlay back (racking element): 3.5 × 20 mm pan-head screws into the sides, top, bottom and every shelf, glued. A rebated back is fixed the same way inside its rebate.",
    "spacingMm": 150,
    "rackingNote": "The back is the racking element: square the carcass (check diagonals) before fixing it. A split back joins over a divider."
  },
  "wallFixing": {
    "required": true,
    "method": "Two steel angle brackets under the top panel, screwed into studs or with fixings suited to the wall (masonry plugs or cavity anchors).",
    "hardware": "2 × steel angle bracket, screws and plugs to suit the wall"
  },
  "antiTip": {
    "required": true,
    "method": "Required above 1000 mm tall: wall fixing as above, plus an anti-tip strap rated for the cabinet. Load the lowest shelves first."
  },
  "warnings": { "maxShelfSpanMm": 800, "antiTipAboveMm": 1000 },
  "assemblySteps": [
    "Cut all panels to finished size; check against the cut list and label each part ID in pencil on a hidden edge.",
    "Glue up any solid panels listed as glue-ups first; flatten and cut them to finished size.",
    "Sand faces to 180 grit and break every arris.",
    "Mark shelf datums (undersides from the floor) on the inside face of both sides and dividers from the same end.",
    "Cut any housings and rebates the cut list names, then drill clearance and countersink holes at each datum.",
    "Glue and screw the bottom and top between the sides with the dividers between them, then the shelves from the bottom up.",
    "Fit the plinth, if any, under the bottom between the sides.",
    "Check diagonals, then glue and screw the back to square the carcass.",
    "Finish (two coats, de-nib between).",
    "Install: fix to the wall with two brackets and the anti-tip strap before loading."
  ],
  "markingDrilling": [
    "Mark every shelf datum (underside from the floor) on the inside face of both verticals, measured from the same (bottom) end.",
    "Screw centres at mid-thickness above each datum line, at 25 mm from the front and back edges and centred.",
    "Clearance 4.5 mm and countersink through the sides; pilot 2.5 mm into the panel edges."
  ],
  "installation": [
    "Stand the bookcase in place and check it is level and plumb; pack under the sides if the floor is uneven.",
    "Fix two angle brackets under the top panel into the wall (studs, or plugs or anchors suited to the wall).",
    "Fit the anti-tip strap before loading any shelf.",
    "Load the lowest shelves first."
  ],
  "tolerances": {
    "panelLength": 0.5,
    "panelWidth": 0.5,
    "squareness": "≤ 1 mm over the diagonal",
    "shelfDatum": 1
  },
  "backConstraint": "Each back piece fits one sheet: min(w, h) ≤ 1220 − 2a and max(w, h) ≤ 2440 − 2a, a = 2 mm; a back too wide for one sheet is split over a divider."
}
